var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nv-app',{attrs:{"navigation":_vm.navigation,"title":"BEE","user":{ can: _vm.$auth.$auth.hasPermissions },"icon":"/images/logo.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }